import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { renameDashboardGroupNameStart } from "store/actions";
import { LayoutContext } from "App/common/hoc/Layout";
import { VALIDATION } from "consts";

function RenameGroup(props) {
  const { lState, lMethods } = React.useContext(LayoutContext);

  const [group, setGroup] = React.useState(lState.popup.params.group);
  const [error, setError] = React.useState({ show: false, msg: "" });

  React.useEffect(() => {
    lMethods.updatePopupParams({
      execute: handleGroupNameChange,
      disable:
        group.groupName.length === 0 ||
        group.groupName === lState.popup.params.group.groupName ||
        error.show
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [group]);

  function handleGroupNameChange() {
    if (group.groupName === "" || group.groupName.trim() === "") {
      setError({ show: true, msg: VALIDATION.groups.empty });
      return;
    }
    const specialChars = /[`!@#$%^&*()+=\[\]{};':"\\|,.<>\/?~]/;
    if (specialChars.test(group.groupName)) {
      setError({ show: true, msg: VALIDATION.groups.specialChars });
      return;
    }

    if (
      Object.values(props.groupsObj.list).filter(
        grp => grp.groupName === group.groupName
      ).length === 0
    ) {
      props.renameDashboardGroupNameStart({
        groupID: group.groupId,
        groupName: group.groupName,
        position: lState.popup.params.position
      });
      lMethods.closePopup();
      lState.popup.params.resetCheckList &&
        lState.popup.params.resetCheckList();
    } else {
      setError({ show: true, msg: VALIDATION.groups.nameExists });
    }
  }

  // function onChangeHandler(val) {
  //   const format = /[ `!@#$%^&*+=\[\]{};'"\\|,.<>\/?~]/;
  //   if (format.test(val)) {
  //     setError({ show: true, msg: VALIDATION.groups.specialChars });
  //     return; //allowing only these characters : "-_:()"
  //   }
  //   if (val.length > 20) {
  //     setError({ show: true, msg: VALIDATION.groups.max });
  //   } else {
  //     setGroup({ ...group, groupName: val });

  //     setError({ show: false, msg: "" });
  //   }
  // }

  function onChangeHandler(val) {
    if (val) {
      const specialChars = /[`!@#$%^&*()+=\[\]{};':"\\|,.<>\/?~]/;
      if (val.length > 20) {
        setError({ show: true, msg: VALIDATION.groups.max });
      } else {
        if (specialChars.test(val)) {
          setError({ show: true, msg: VALIDATION.groups.specialChars });
        } else {
          setError({ show: false, msg: "" });
        }
        setGroup({ ...group, groupName: val });
      }
    } else {
      setGroup({ ...group, groupName: "" });
    }
  }

  return (
    <React.Fragment>
      <div className="inpt_wrp">
        <p className="lbl_txt">Name</p>
        <input
          type="text"
          className="input_text"
          value={group.groupName}
          onChange={e => onChangeHandler(e.target.value)}
          onKeyDown={e => e.key === "Enter" && handleGroupNameChange()}
          autoFocus
        />
        <span className="error-msg">{error.msg}</span>
      </div>
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    groupsObj: state.dashboard.groups
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      renameDashboardGroupNameStart
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RenameGroup);
